import type { SearchParams } from '@/server/searchParams.ts';
import { removeParameters } from '@/app/common/urlParametersUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { SEARCH_FILTER_PARAMS } from '@/app/common/filters/core/filterDefinitions.ts';

const PARAMS_TO_REMOVE_BASE: URLParameters[] = [URLParameters.OFFSET, URLParameters.PAGE, URLParameters.MAP_AREA];

const SEARCH_FILTER_PARAMS_TO_REMOVE_FOR_NEW_SEARCH = SEARCH_FILTER_PARAMS.filter(
  (paramName) => paramName !== URLParameters.PINK_PEOPLE
);
const PARAMS_TO_REMOVE: URLParameters[] = [...PARAMS_TO_REMOVE_BASE, ...SEARCH_FILTER_PARAMS_TO_REMOVE_FOR_NEW_SEARCH];

type CreateNewSearchParams = {
  searchParams: SearchParams;
};

export const createNewSearchParamsAndRemoveSpecificParams = ({
  searchParams,
  paramsToRemove,
}: {
  searchParams: SearchParams;
  paramsToRemove: URLParameters[];
}): SearchParams => {
  const searchParamsNormalised: SearchParams = JSON.parse(JSON.stringify(searchParams || {}));

  const newSearchQueryString = {
    ...removeParameters(searchParamsNormalised, paramsToRemove),
    ...(searchParamsNormalised.pinkpeople ? { pinkpeople: searchParamsNormalised.pinkpeople } : {}),
  };

  return newSearchQueryString;
};

export const createNewSearchParams = ({ searchParams }: CreateNewSearchParams): SearchParams =>
  createNewSearchParamsAndRemoveSpecificParams({ searchParams, paramsToRemove: PARAMS_TO_REMOVE });

export const createNewSearchParamsBase = ({ searchParams }: CreateNewSearchParams): SearchParams =>
  createNewSearchParamsAndRemoveSpecificParams({ searchParams, paramsToRemove: PARAMS_TO_REMOVE_BASE });
